
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/examples/your-wins",
      function () {
        return require("private-next-pages/design-system/examples/your-wins.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/examples/your-wins"])
      });
    }
  